import React from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import IconButton from '@material-ui/core/IconButton'
import Menu from '@material-ui/core/Menu'
import MoreVertIcon from '@material-ui/icons/MoreVert'
import SettingsMenuItems from '../containers/SettingsMenuItems'
import { getBreakpointsEnable } from '../../../lib'

const styles = {
}

class SettingsMenu extends React.Component {
  state = {
    anchorEl: null,
  }

  handleOpen = (event) => {
    this.setState({ anchorEl: event.currentTarget })
  }

  handleClose = (name) => {
    this.setState({ anchorEl: null })
  }

  render() {
    const { theme, user, width } = this.props
    const { anchorEl } = this.state
    const { md } = getBreakpointsEnable(theme, width)
    if (md === false) {
      return (
        <div>
          <IconButton onClick={this.handleOpen} color='inherit'>
            <MoreVertIcon/>
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={this.handleClose}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
          >
            <SettingsMenuItems user={user} onClose={this.handleClose}/>
          </Menu>
        </div>
      )
    }
    else {
      return (<div></div>)
    }
  }
}

export default withStyles(styles, { withTheme: true })(SettingsMenu)


// WEBPACK FOOTER //
// ./src/Pages/Settings/components/SettingsMenu.js